<template>
  <div class="p-15">
    <el-card class="m-b-20">
      <el-form ref="ruleForm" :model="searchForm" inline>
        <el-form-item prop="query.status">
          <el-select v-model="searchForm.query.status" clearable placeholder="审核状态">
            <el-option v-for="item in ExamineStatus.options()" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="init" type="primary">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card>
      <template #header>参与名单</template>
      <el-table :data="tableData">
        <el-table-column label="用户昵称">
          <template #default="{ row }">
            {{ row.user ? row.user.nickName : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="手机号码">
          <template #default="{ row }">
            {{ row.user ? row.user.phoneNumber : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="性别">
          <template #default="{ row }">
            {{ row.user ? (row.user.gender ? '男' : '女') : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="城市">
          <template #default="{ row }">
            {{ (row.user && row.user.city) || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="提交时间" width="200px" prop="createdAt" />
        <el-table-column label="审核状态" width="200px">
          <template #default="{ row }">
            <badge :badge_type="ExamineStatus.filter(row.status).type">{{ ExamineStatus.filter(row.status).label }}</badge>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template #default="{ row }">
            <router-link :to="{ name: 'interaction-award-questionnaire-data-detail', query: { id: row.id } }">
              <el-button type="text">详情</el-button>
            </router-link>
            <template v-if="row.status === ExamineStatus.normal">
              <el-button type="text" :disabled="!row.can_agree" @click="onExamize(row, 'success')">同意</el-button>
              <el-button type="text" class="color-danger" :disabled="!row.can_refuse" @click="onExamize(row, 'refuse')">拒绝</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <pagination :changed="onChange" :total="total" :pagination="searchForm.pagination" />
    </el-card>
    <el-dialog :visible.sync="examineModal.visible" :title="modalTitle" @close="setExamineModalVisible(false)" width="500px" :close-on-click-modal="false">
      <el-form ref="examineForm" :rules="examineModal.rules" :model="examineModal.form" label-width="auto">
        <el-form-item prop="remark" label="备注内容">
          <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 5 }" v-model="examineModal.form.remark" placeholder="请输入备注" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="setExamineModalVisible(false)">取消</el-button>
        <el-button type="primary" @click="onExamineModalSubmit">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { questionnaireListApi } from '@/api/interaction/award-questionnaire'
import { ExamineStatus } from './enums'
import { cloneDeep } from 'lodash'

export default {
  data() {
    return {
      ExamineStatus,
      tableData: [],
      searchForm: {
        query: {
          state: undefined
        },
        pagination: {
          currentPage: 1,
          limit: 10
        },
        withRels: ['user']
      },
      total: 0,
      examineModal: {
        visible: false,
        row: {},
        form: {
          status: undefined,
          remark: undefined
        },
        rules: {
          remark: [{ required: true, message: '请输入备注', trigger: ['blur', 'change'] }]
        }
      }
    }
  },
  computed: {
    modalTitle() {
      switch (this.examineModal.form.status) {
        case ExamineStatus.success:
          return '同意'
        case ExamineStatus.refuse:
          return '拒绝'
      }
    }
  },
  methods: {
    onExamineModalSubmit() {
      this.$refs.examineForm.validate(async valid => {
        if (valid) {
          const { form, row } = this.examineModal
          const param = cloneDeep(form)
          if (this.modalSubmitLocked) return
          this.modalSubmitLocked = true
          try {
            await questionnaireListApi.update(row.id, param)
            this.$message.success('审核成功')
            this.init()
            this.setExamineModalVisible(false)
          } finally {
            this.$nextTick(() => {
              this.modalSubmitLocked = false
            })
          }
        }
      })
    },
    setExamineModalVisible(visible) {
      this.examineModal.visible = visible
    },
    onExamize(row, status) {
      this.examineModal.row = row
      this.examineModal.form.status = status
      this.setExamineModalVisible(true)
      this.$nextTick(() => {
        this.$refs.examineForm.resetFields()
      })
    },
    onChange({ pagination }) {
      this.searchForm.pagination = pagination
      this.init()
    },
    reset() {
      this.$refs.ruleForm.resetFields()
      this.init()
    },
    async init() {
      const param = cloneDeep(this.searchForm)
      param.query.activityId = this.$route.query.id
      const { collection, meta } = await questionnaireListApi.paginator(param)
      this.tableData = collection
      this.total = meta.total
    }
  },
  created() {
    this.init()
  }
}
</script>
<style scoped lang="less">
.question-title {
  font-size: 16px;
  font-weight: bold;
  .color-primary {
    color: #1890ff;
  }
}
.color-danger {
  color: #f56c6c;
  &[disabled='disabled'] {
    color: #c0c4cc;
  }
}
</style>
